import { useSelector } from 'react-redux'
import { useMemo } from 'react'
import { userSelector } from '@selectors/app.ts'
import { MobileAppFeature } from '@src/types.ts'
import {
  ProductExplanationScreenTypes,
  VideoCallProductTypes,
} from '@src/screens/Marketplace/components/NewMarketplace/definitions'

const getVideoCallProductType = (
  features: MobileAppFeature[],
  screen?: ProductExplanationScreenTypes,
) => {
  if (screen === ProductExplanationScreenTypes.PaidVideoCalls) {
    return VideoCallProductTypes.Paid
  }

  if (features.includes(MobileAppFeature.HealthCoachingVideoCalls)) {
    return VideoCallProductTypes.HealthCoaching
  }

  return VideoCallProductTypes.Insurance
}

export const getVideoCallProductInfo = (
  features: MobileAppFeature[],
  screen?: ProductExplanationScreenTypes,
) => {
  const videoCallProductType = getVideoCallProductType(features, screen)

  return {
    videoCallProductType,
    isHealthCoachingVideoCallProductType:
      videoCallProductType === VideoCallProductTypes.HealthCoaching,
    isInsuranceVideoCallProductType: videoCallProductType === VideoCallProductTypes.Insurance,
  }
}

export const useVideoCallProductType = (screen?: ProductExplanationScreenTypes) => {
  const user = useSelector(userSelector)

  return useMemo(() => getVideoCallProductInfo(user?.features || [], screen), [user, screen])
}
